// @flow
import PageNode from 'components/page/PageNode';
import { connect } from 'react-redux';
import { fetchPageDetail, fetchPageNode } from 'actions/pageActions';

import type { DispatchProps, StateProps } from 'components/page/PageNode';
import type { DispatchType, StateType } from 'types/Actions';

import { withRouter } from 'react-router-dom';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      liste_enfants: state.pageNodeState.pageNode.liste_enfants,
      sidebar_content: state.pageNodeState.pageNode.sidebar_content,
      pageDetailSidebar: state.pageDetailState.sidebar_content,
      contentNode: state.pageNodeState.pageNode.content,
      status: state.pageNodeState.status,
      template: state.pageNodeState.pageNode.template,
      templateDetail: state.pageDetailState.template,
      title_previsu: state.pageDetailPreviewState.title,
      redirection: state.pageNodeState.pageNode.redirection,
    }),
    (dispatch: DispatchType): DispatchProps => ({
      fetchPageDetail: (slug: string) => dispatch(fetchPageDetail(slug)),
      fetchPageNode: (slug: string) => dispatch(fetchPageNode(slug))
    })
  )(PageNode)
);
